import dayjs from 'dayjs';

function getPreferredAddress(member) {
  const addresses = Array.isArray(member?.address) ? member.address : [];
  const preferred = member?.preferred_address;
  if (preferred && typeof preferred === 'object') return preferred;
  return addresses.find((address) => String(address?.id) === String(preferred))
    || addresses.find((address) => address?.address_type === 'private')
    || addresses[0]
    || null;
}

function getLanguageName(languageCode, locale) {
  if (!languageCode) return '';
  try {
    return new Intl.DisplayNames([locale], { type: 'language' }).of(languageCode) || languageCode;
  } catch (_error) {
    return languageCode;
  }
}

function getAvatarColorIndex(name) {
  const hash = Array.from(name).reduce(
    (result, character) => result + character.codePointAt(0),
    0,
  );

  return hash % 7;
}

export function mapMemberContext(details, fallbackMember, locale) {
  const address = getPreferredAddress(details);
  const name = [details?.name, details?.last_name].filter(Boolean).join(' ') || fallbackMember?.label || '';
  return {
    avatarColorIndex: getAvatarColorIndex(name),
    birthday: details?.birth_day ? dayjs(details.birth_day).locale(locale).format('D MMMM') : '',
    initial: name.trim().charAt(0).toLocaleUpperCase(locale),
    language: getLanguageName(details?.preferred_language, locale),
    location: [address?.city, address?.country || details?.country].filter(Boolean).join(', '),
    name,
    notes: details?.pma_notes || '',
    phone: details?.phone ? `${details?.prefix_phone || ''}${details.phone}` : '',
    primaryEmail: details?.email || '',
  };
}
